import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "./../../common/config";
import {
  ErrorNotification,
  SuccessNotification,
} from "../../tosterNotification/tosters";

const OtpVerification = ({
  formValues,
  setFormValues,
  formErrors,
  setFormErrors,
  setOtpVerified,
  setIsLoading,
}) => {
  const [disableResend, setDisableResend] = useState(false);
  const [timer, setTimer] = useState(20);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const validate = (values) => {
    const errors = {};
    if (!values.otp) errors.otp = "OTP is required";
    else if (!/^\d{6}$/.test(values.otp)) errors.otp = "OTP must be 6 digits";
    return errors;
  };

  const verifyOtp = async (email, otp) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/verify-otp`, {
        email,
        otp,
      });
      if (response.data.success) {
        setOtpVerified(true);
        SuccessNotification("OTP Verified Successfully!");
      } else {
        ErrorNotification("Invalid OTP");
        throw new Error("Invalid OTP");
      }
    } catch (error) {
      console.error("OTP Verification Error:", error);
      ErrorNotification(`OTP Verification Error: ${error.message}`);
      setFormErrors((prev) => ({ ...prev, otp: "Invalid OTP" }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validate(formValues);
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      verifyOtp(formValues.email, formValues.otp);
    }
  };

  const handleResendOTP = async (email) => {
    setFormErrors((prev) => ({ ...prev, otp: "" }));

    setDisableResend(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/send-otp`, {
        email,
      });
      if (response.data.success) {
        SuccessNotification("OTP sent successfully!");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      ErrorNotification("Failed to resend OTP");
    }

    let countdown = 20;
    const interval = setInterval(() => {
      setTimer(countdown);
      countdown -= 1;
      if (countdown < 0) {
        clearInterval(interval);
        setDisableResend(false);
      }
    }, 1000);
  };

  return (
    <>
      <h4 className="text-center">OTP has been sent! Please verify.</h4>
      <form onSubmit={handleSubmit} className="axil-contact-form">
        <div className="form-group">
          <label>Email address*</label>
          <input
            type="email"
            className="form-control"
            placeholder="name@gmail.com"
            name="email"
            value={formValues.email}
            onChange={handleChange}
            disabled
          />
        </div>
        <p className="text-red">{formErrors.email}</p>
        <div className="form-group">
          <label>OTP*</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter OTP"
            name="otp"
            value={formValues.otp}
            onChange={handleChange}
          />
        </div>
        <p className="text-red">{formErrors.otp}</p>
        <div className="form-group mx-3 d-flex gap-3 justify-content-center ">
          <button
            type="submit"
            className="col-lg-4 try-free-btn btn-fluid btn-primary"
            name="submit-btn"
          >
            Verify OTP
          </button>
          <button
            type="submit"
            className="col-lg-4 try-free-btn btn-fluid btn-primary"
            name="submit-btn"
            onClick={() => handleResendOTP(formValues.email)}
            disabled={disableResend}
          >
            {disableResend ? `Resend OTP in ${timer}s` : "Resend OTP"}
          </button>
        </div>
      </form>
    </>
  );
};

export default OtpVerification;
